import { LogLevel } from "@azure/msal-browser";

// La autoridad se resuelve por configuración para que el mismo código sirva a los
// dos tenants durante la transición:
//   Azure AD B2C -> https://halleyb2c.b2clogin.com/halleyb2c.onmicrosoft.com/B2C_1_Signin
//   Entra CIAM   -> https://login.halley.app/{tenantId}
// En Entra External ID el user flow se resuelve por client_id y no por la ruta de la
// autoridad, por eso allí no participan las variables *_USER_JOURNEY.
const B2C_AUTHORITY_DOMAIN = "halleyb2c.b2clogin.com";

const authority = process.env.REACT_APP_AUTHORITY
    || `https://${B2C_AUTHORITY_DOMAIN}/halleyb2c.onmicrosoft.com/${process.env.REACT_APP_SIGNIN_USER_JOURNEY}`;

const authorityDomain = process.env.REACT_APP_AUTHORITY_DOMAIN || B2C_AUTHORITY_DOMAIN;

// El portal se sirve en la raíz de su host, así que `window.location.origin` alcanza;
// aun así el valor se deja por configuración para no depender de dónde se monte.
const redirectUri = process.env.REACT_APP_REDIRECT_URI || window.location.origin;

// Idioma de la página de login hospedada por el IdP. Se fija en español de forma
// incondicional, sin mirar el navegador: Edge no envía `Accept-Language` y
// `navigator.language` reporta el idioma del navegador, no el del sistema operativo.
//
// `ui_locales` define el idioma de la UI. `mkt` viaja además al evento OnOtpSend como
// `client.market` y es lo que hace que el correo del código llegue en el mismo idioma
// que la pantalla. Los dos deben ir juntos.
const uiLocale = "es-ES";

export const localeQueryParameters = {
    ui_locales: uiLocale,
    mkt: uiLocale
};

const auth = {
    clientId: process.env.REACT_APP_CLIENT_ID,
    authority: authority,
    knownAuthorities: [authorityDomain],
    redirectUri: redirectUri,
    postLogoutRedirectUri: redirectUri,
    navigateToLoginRequestUrl: true
}

const cache = {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: false,
}

const system = {
    loggerOptions: {
        loggerCallback: (level, message, containsPii) => {
            if (containsPii) {
                return;
            }

            switch (level) {
                case LogLevel.Error:
                    console.error(message);
                    return;
                case LogLevel.Verbose:
                    console.debug(message);
                    return;
                case LogLevel.Warning:
                    console.warn(message);
                    return;
                default:
                    console.info(message);
                    break;
            }
        }
    }
}

export const msalConfig = {
    auth: auth,
    cache: cache,
    system: system
};

// Se pide el scope del API en el login para que el consentimiento ocurra al entrar
// y no en el primer fetch.
export const loginRequest = {
    scopes: [
        "openid",
        "profile",
        "email",
        "offline_access",
        process.env.REACT_APP_BACKEND_API_SCOPE
    ].filter(Boolean),
    extraQueryParameters: localeQueryParameters
};
